import { Box, Typography } from "@mui/material";
import { CURRENCY_INR } from "../../utils/constant";

const SummaryTable = ({ rfq, groupedData, bidData }) => {
  if (!rfq || !groupedData) return null;

  const groupedBySection = rfq.rfqWorkItems.reduce((acc, item) => {
    const section = item.section || "Uncategorized";
    acc[section] = acc[section] || [];
    acc[section].push(item);
    return acc;
  }, {});

  const vendorTotals = {};
  const vendorTotalsWithGST = {};

  const sectionTotals = Object.entries(groupedBySection).map(
    ([section, items]) => {
      const row = { section };

      Object.keys(groupedData).forEach((vendor) => {
        let total = 0;
        let totalWithGST = 0;

        const mostRecentBid = [...groupedData[vendor]].sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate),
        )[0];

        items.forEach((item) => {
          const normalize = (str) => str?.replace(/\s+/g, " ").trim().toLowerCase();
          const bw = mostRecentBid?.bidWorkItems.find(
            (bw) =>
              bw.code === item.code &&
              bw.quantity === item.quantity &&
              normalize(bw.description) === normalize(item.description) &&
              bw.unit === item.unit
              // bw.gst === item.gst,
          );
          if (!bw) return;
          let value = 0;
          if (bw.currency.currency.shortform !== CURRENCY_INR) {
            value = bw.quantity * bw.rate * bw.currency.rate;
          } else {
            value = bw.quantity * bw.rate;
          }
          const valueWithGST = value + (value * bw.gst) / 100;

          total += value;
          totalWithGST += valueWithGST;

          vendorTotals[vendor] = (vendorTotals[vendor] || 0) + value;
          vendorTotalsWithGST[vendor] =
            (vendorTotalsWithGST[vendor] || 0) + valueWithGST;
        });

        row[vendor] = { total, totalWithGST };
      });

      return row;
    },
  );

  return (
    <Box className="dashboard-container" mb={3}>
      <Typography variant="h6" mb={2}>
        Item Group wise Summary
      </Typography>
      <Box sx={{ overflowX: "auto" }}>
        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: `${bidData && bidData?.length * 100}px`,
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  padding: "10px",
                  textAlign: "left",
                  minWidth: "150px",
                }}
              >
                Item Group
              </th>
              {Object.keys(groupedData).map((vendor) => (
                <th
                  key={vendor}
                  style={{ padding: "10px", textAlign: "center" }}
                >
                  {vendor}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sectionTotals.map((row) => (
              <tr key={row.section}>
                <td style={{ padding: "10px", fontWeight: "bold" }}>
                  {row.section}
                </td>
                {Object.keys(groupedData).map((vendor) => (
                  <td
                    key={vendor}
                    style={{ padding: "10px", textAlign: "center" }}
                  >
                    ₹
                    {new Intl.NumberFormat("en-IN", {
                      style: "decimal",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(row[vendor]?.total || 0)}
                  </td>
                ))}
              </tr>
            ))}
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ padding: "10px" }}>Total (Excl. GST)</td>
              {Object.keys(groupedData).map((vendor) => (
                <td
                  key={vendor}
                  style={{ padding: "10px", textAlign: "center" }}
                >
                  ₹
                  {new Intl.NumberFormat("en-IN", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(vendorTotals[vendor] || 0)}
                </td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ padding: "10px" }}>Total (Incl. GST)</td>
              {Object.keys(groupedData).map((vendor) => (
                <td
                  key={vendor}
                  style={{ padding: "10px", textAlign: "center" }}
                >
                  ₹
                  {new Intl.NumberFormat("en-IN", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(vendorTotalsWithGST[vendor] || 0)}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

export default SummaryTable;